
const LANDING_PAGE_HEADER_PROPS = {
  desktopMenuLinks: [
    {
      type: 'primary' as const,
      title: 'Request a demo',
      href: '',
      action: 'demo' as const,
    },
    {
      type: 'secondary' as const,
      title: 'Try for Free',
      href: '',
      action: 'trial' as const,
    },
  ],
  mobileMenuLinks: [
    {
      type: 'primary' as const,
      title: 'Request a demo',
      href: '',
      action: 'demo' as const,
    },
    {
      type: 'secondary' as const,
      title: 'Try for free',
      href: '',
      action: 'trial' as const,
    },
  ],
};

export default LANDING_PAGE_HEADER_PROPS;
